module.exports = __webpack_public_path__ + "static/media/tenant5-2.dd36b327.png";